initCartDrawer();

function initCartDrawer() {
  document.querySelector('.shopify-section-cart-drawer').addEventListener('click', (event) => {
    const clickEventPath = event.composedPath().slice(0, -2);

    for (const element of clickEventPath) {
      const clickAction = element?.getAttribute('data-click-action');

      if (clickAction === 'close-cart-drawer') {
        closeCartDrawerHandler(element);
        window.mx.showGorgiasButton();
        break;
      } else if (clickAction === 'remove-item-from-cart') {
        removeItemFromCartHandler(element);
        break;
      } else if (clickAction === 'set-coupon-code') {
        setCouponCodeHandler(element);
        break;
      } else if (clickAction === 'cart-item-add') {
        addItemToCartHandler(element);
        break;
      }
    }
  });

  document.querySelector('.shopify-section-cart-drawer').addEventListener('focusin', (event) => {
    event.target.addEventListener('keyup', handleCouponConfirmation);
  });

  document.querySelector('.mx-cart-drawer').addEventListener('focusout', (event) => {
    event.target.removeEventListener('keyup', handleCouponConfirmation);
  });

  // loadRecommendedProducts();
}

async function loadRecommendedProducts() {
  try {
    const cartRecommendationsContainer = document.querySelector('.cart-recommendations-container');
    const cartRecommendationsEndpoint = cartRecommendationsContainer.dataset.url;

    const cartRecommendationsMarkup = await fetch(cartRecommendationsEndpoint).then((response) => response.text());

    const parser = new DOMParser();
    const newCartRecommendationsContainer = parser
      .parseFromString(cartRecommendationsMarkup, 'text/html')
      .querySelector('.cart-recommendations-container');

    cartRecommendationsContainer.innerHTML = newCartRecommendationsContainer.innerHTML;
  } catch (error) {
    console.error(error);
  }
}

function closeCartDrawerHandler(closeButton) {
  closeButton.closest('.shopify-section-cart-drawer').querySelector('.mx-cart-drawer').removeAttribute('data-open');
  document.documentElement.removeAttribute('data-locked');
  window.scrollTo(0, -1 * parseInt(document.documentElement.style.top));
  document.documentElement.style.top = null;
  document.documentElement.style.scrollBehavior = null;
}

async function removeItemFromCartHandler(removeButton) {
  const itemKey = removeButton.closest('.cart-item-container').getAttribute('data-line-key');

  const sectionId = removeButton.closest('.shopify-section-cart-drawer').id.split('shopify-section-').pop();

  try {
    const cartUpdateJson = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [itemKey]: 0,
        },
        sections: [sectionId],
      }),
    }).then((response) => response.json());

    refreshCartUserInterface(cartUpdateJson.sections[sectionId]);
  } catch (error) {
    console.error('Error removing the product from cart', error);
  }
}

async function setCouponCodeHandler(applyCouponButton) {
  const couponInput = applyCouponButton.previousElementSibling;
  const couponCode = couponInput.value.toUpperCase();
  const couponCodeLoadingString = applyCouponButton.parentElement.getAttribute('data-loading-string');

  couponInput.value = '';
  couponInput.placeholder = couponCodeLoadingString;
  couponInput.blur();

  if (couponCode === null) return;

  try {
    await fetch('/discount/' + couponCode);

    const sectionId = applyCouponButton.closest('.shopify-section-cart-drawer').id.split('shopify-section-').pop();

    const sectionJson = await fetch(`/?sections=${sectionId}`).then((response) => response.json());

    refreshCartUserInterface(sectionJson[sectionId]);

    requestAnimationFrame(() => {
      const refreshedCouponMessage = document.querySelector('.cart-coupon-message');
      if (refreshedCouponMessage && refreshedCouponMessage.dataset.hasDiscount === '0') {
        refreshedCouponMessage.classList.add('is-active');
        setTimeout(() => {
          refreshedCouponMessage.classList.remove('is-active');
        }, 7000);
      }
    });

  } catch (error) {
    console.error('Error applying the coupon code', error);
  }
}

function refreshCartUserInterface(sectionMarkup) {
  const sectionHtml = new DOMParser().parseFromString(sectionMarkup, 'text/html');

  const cartDrawer = document.querySelector('.mx-cart-drawer');
  const newCartDrawer = sectionHtml.querySelector('.mx-cart-drawer');

  const newCartItemCount = newCartDrawer.getAttribute('data-cart-item-count');
  document.querySelectorAll('[data-cart-item-count]').forEach((element) => {
    element.setAttribute('data-cart-item-count', newCartItemCount);
  });

  cartDrawer.replaceChildren(...newCartDrawer.children);

  initAnnouncementBar();
}

function handleCouponConfirmation(event) {
  if (event.key === 'Enter') {
    setCouponCodeHandler(event.target.nextElementSibling);
  }
}

async function addItemToCartHandler(addButton) {
  const variantId = addButton.getAttribute('data-product-id');
  const sectionId = addButton.closest('.shopify-section-cart-drawer').id.replace('shopify-section-', '');

  try {
    // 1) Ajout
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    // 2) Récupération de la section cart drawer mise à jour
    const updatedSections = await fetch(`/?sections=${sectionId}`).then(res => res.json());

    // 3) Remplacement du HTML
    refreshCartUserInterface(updatedSections[sectionId]);
  } catch (error) {
    console.error('Error adding product to cart', error);
  }
}

const DEFAULT_SWITCH_DELAY = 5000;
let carouselInterval;

/**
 * Initializes the announcement bar carousel.
 * Can be called multiple times safely (clears previous interval).
 */
function initAnnouncementBar() {
  stopCarousel();

  const announcementBar = document.querySelector('.cart-announcement');
  if (!announcementBar) return;

  const announcements = announcementBar.querySelector('.cart-announcement-list');
  if (!announcements) return;

  const switchDelay = parseInt(announcements.getAttribute('data-switch-delay') ?? DEFAULT_SWITCH_DELAY);

  announcementBar.addEventListener('mouseenter', stopCarousel);
  announcementBar.addEventListener('mouseleave', () => {
    startCarousel(announcements, switchDelay);
  });

  startCarousel(announcements, switchDelay);
}

/**
 * Switches the announcement in the carousel.
 * @param {HTMLElement} announcements - The container element for the announcements.
 * @param {number} switchDelay - The delay in milliseconds between each announcement switch.
 */
function switchAnnouncement(announcements, switchDelay) {
  const firstAnnouncement = announcements.firstElementChild;

  if (!firstAnnouncement) return;

  const announcementWidth = firstAnnouncement.offsetWidth;

  announcements.scrollBy({ left: announcementWidth, behavior: 'smooth' });

  setTimeout(() => {
    announcements.append(firstAnnouncement.cloneNode(true));
    announcements.removeChild(firstAnnouncement);

    announcements.scroll({ left: 0 });
  }, switchDelay / 2);
}

/**
 * Starts the carousel to switch announcements at a specified interval.
 * @param {HTMLElement} announcements - The container element for the announcements.
 * @param {number} switchDelay - The delay in milliseconds between each announcement switch.
 */
function startCarousel(announcements, switchDelay) {
  carouselInterval = setInterval(() => {
    switchAnnouncement(announcements, switchDelay);
  }, switchDelay);
}

/**
 * Stops the carousel from switching announcements.
 */
function stopCarousel() {
  clearInterval(carouselInterval);
}

// Initialize the announcement bar on initial load
initAnnouncementBar();
